import { format } from 'date-fns';
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';

class DateTimeHelper {
    static dateFormat(currDate, dateFormat) {
        try {
            if (typeof currDate === 'string' && currDate.includes(' ')) {
                return format(new Date(currDate.split(' ').join('T')), dateFormat);
            }
            return format(new Date(currDate), dateFormat);
        } catch (err) {
            console.log("DATE FORMAT ERROR");
            return '';
        }
    }

    static dateNow(dateFormat) {
        return format(Date.now(), dateFormat);
    }

    static displayTimeCode(ms, hasHours, fps = ArticleTypes.FPS) {
        if (ms && fps) {
            ms = ms * 1000;
            let frames = parseInt((ms / 1000 * fps) % fps);
            let seconds = parseInt((ms / 1000) % 60);
            let minutes = parseInt((ms / (1000 * 60)) % 60);
            let hours = parseInt((ms / (1000 * 60 * 60)) % 24);

            hours = (hours < 10) ? "0" + hours : hours;
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            seconds = (seconds < 10) ? "0" + seconds : seconds;
            frames = (frames < 10) ? "0" + frames : frames;
            if (hasHours) return hours + ":" + minutes + ":" + seconds + ":" + frames;
            return minutes + ":" + seconds + ":" + frames;
        }
    }

    static convertToTime(tc, hasHours, fps = ArticleTypes.FPS) {
        let tcArray = tc.split(":");
        let max = hasHours ? 4 : 3;
        let i = hasHours ? 1 : 0;
        if (tcArray && tcArray.length === max) {
            let hours = hasHours ? parseInt(tcArray[0]) * 60 * 60 : 0;
            let minutes = parseInt(tcArray[i]) * 60;
            let seconds = parseInt(tcArray[i + 1]);
            let frames = parseInt(tcArray[i + 2]) * (1 / fps);
            let totalTime = hours + minutes + seconds + frames;
            return totalTime.toFixed(1);
        }
        return tc;
    }

    static isTimeCode(tc, hasHours) {
        let tcArray = tc.split(":");
        let max = hasHours ? 4 : 3;
        if (tcArray && tcArray.length === max
            && tcArray.every(item => (parseInt(item) || item == '00')))
            return true;
        return false;
    }
}

export default DateTimeHelper;